import Chip from './Chip.js';
export { default } from './Chip.js';
//# sourceMappingURL=index.js.map
